import Big from "big.js";
import { darken, lighten, readableColor } from "polished";
import qs from "qs";
export const CoreUtils = {
    string: {
        seoId: (s) => {
            s = s.toLowerCase();
            s = s.replace(/\s+/g, "-");
            s = s.replace(/[^a-z0-9_-]/, "");
            s = s.replace(/\?/g, "");
            s = s.replace(/\(/g, "");
            s = s.replace(/\)/g, "");
            s = s.replace(/"/g, "");
            s = s.replace(/&#39;/g, "");
            return s;
        },
        sort: (a, b) => {
            if (a === b)
                return 0;
            if (a > b)
                return 1;
            return -1;
        },
        remove_linebreaks: (str) => {
            return str.replace(/(\r\n\t|\n|\r\t)/gm, "");
        },
        replace_spaces: (s, replace) => {
            return s.replace(/ /g, replace);
        },
        cap_first: (s) => s.charAt(0).toUpperCase() + s.slice(1),
    },
    currency: {
        centsToDecimal(amount, precision) {
            const ratio = Math.pow(10, precision);
            return new Big(amount).div(ratio).toFixed(precision);
        },
        decimalToCents(amount, precision) {
            return parseInt(new Big(amount).times(Math.pow(10, precision)).toFixed(0), 10);
        },
        precision_to_step: (precision) => {
            if (precision === 0)
                return "1";
            if (precision === 1)
                return "0.1";
            if (precision === 2)
                return "0.01";
            if (precision === 3)
                return "0.001";
            if (precision === 4)
                return "0.0001";
            return "0.01";
        },
    },
    colors: {
        shadeAlternate(shade, color) {
            if (readableColor(color) === "#000") {
                return darken(shade, color);
            }
            else {
                return lighten(shade, color);
            }
        },
        stringFromRgba(obj) {
            return `rgba(${obj.r}, ${obj.g}, ${obj.b}, ${obj.a})`;
        },
        rgbaObjectFromString(s) {
            if (!s)
                return { r: 0, g: 0, b: 0, a: 1 };
            if (s.indexOf("rgba") !== -1) {
                const temp = s.split("rgba(")[1].slice(0, -1).split(",");
                return {
                    r: parseInt(temp[0], 10),
                    g: parseInt(temp[1], 10),
                    b: parseInt(temp[2], 10),
                    a: parseFloat(temp[3]),
                };
            }
            else {
                const temp = s.split("rgb(")[1].slice(0, -1).split(",");
                return {
                    r: parseInt(temp[0], 10),
                    g: parseInt(temp[1], 10),
                    b: parseInt(temp[2], 10),
                    a: 1,
                };
            }
        },
    },
    image: {
        uc: (image, transformations) => {
            if (!image || typeof image !== "string")
                return undefined;
            if (image.indexOf("http") !== -1) {
                return image;
            }
            const base = `https://bno-restaurant-images.imgix.net/${image}`;
            if (!transformations) {
                return `${base}?lossless=1`;
            }
            if (!transformations.fit) {
                transformations.fit = "crop";
            }
            if (typeof transformations.lossless === "undefined") {
                transformations.lossless = 1;
            }
            return `${base}?${qs.stringify(transformations)}`;
        },
        s3: (image) => {
            if (!image || typeof image !== "string")
                return undefined;
            return `https://bno-restaurant-images.s3-ap-southeast-2.amazonaws.com/${image}`;
        },
    },
    ui: {
        breakpoint(width) {
            if (width >= 1366)
                return "xxl";
            else if (width >= 1140)
                return "xl";
            else if (width >= 1024)
                return "lg";
            else if (width >= 720)
                return "md";
            else if (width >= 480)
                return "sm";
            return "xs";
        },
        breakpoints: {
            xs: 360,
            sm: 480,
            md: 720,
            mmd: 890,
            lg: 1024,
            xl: 1140,
            xxl: 1366,
        },
    },
    fns: {
        wait(duration) {
            return new Promise((resolve) => {
                setTimeout(() => resolve(), duration);
            });
        },
    },
};
//# sourceMappingURL=index.js.map